import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import TechImagePanel from '@/components/feature/TechImagePanel';
import Hero from './components/Hero';
import ExperienceSelector from './components/ExperienceSelector';
import OperationPanel from './components/OperationPanel';

export default function Experience() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <SEO
        title="体验九畴云市 | 五角色模拟运营环境"
        description="体验九畴云市五角色模拟运营环境，选择消费者云社员云店长供应商县域运营者身份，亲身体验县域数字商业基础设施的完整运营链路。"
        keywords="体验九畴云市,模拟运营,消费者,云社员,云店长,供应商,县域运营者"
        path="/experience"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '体验九畴云市',
          description: '五角色模拟运营环境',
        }}
      />
      <main>
        <Hero />
        <ExperienceSelector />
        <TechImagePanel
          eyebrow="模拟运营环境"
          title="从介绍项目，到亲自体验项目"
          desc="选择一个角色，走进九畴云市的模拟运营环境，亲眼看到一笔订单如何跑通、一笔价值如何清分。"
          chips={['消费者', '云社员', '云店长', '供应商', '县域运营者']}
          stats={[
            { value: '5 角色', label: '模拟身份' },
            { value: '下单', label: '订单流' },
            { value: '清分', label: '数据看板' },
          ]}
          imageUrl="https://readdy.ai/api/search-image?query=Abstract%20interactive%20operations%20dashboard%20hologram%2C%20deep%20dark%20ink%20navy%20background%2C%20glowing%20emerald%20and%20gold%20charts%20order%20streams%20and%20settlement%20metrics%20floating%20in%20dark%20space%2C%20digital%20commerce%20control%20room%2C%20minimal%20geometric%20composition%2C%20cinematic%20lighting%2C%20high%20detail&width=1600&height=900&seq=jiuchou-panel-exp&orientation=landscape"
          imageAlt="体验九畴云市 模拟运营环境"
        />
        <OperationPanel />
      </main>
      <Footer />
    </div>
  );
}